import React from 'react';
import { ChevronRight } from 'lucide-react';

interface UserSettingsSectionsProps {
  isLoggedIn: boolean;
  onOpenAccount: () => void;
  onOpenDisplay: () => void;
  onOpenQimen: () => void;
  onOpenNotice: () => void;
}

const UserSettingsSections: React.FC<UserSettingsSectionsProps> = ({
  isLoggedIn,
  onOpenAccount,
  onOpenDisplay,
  onOpenQimen,
  onOpenNotice,
}) => {
  return (
    <div className="space-y-3">
      {isLoggedIn && (
        <button
          type="button"
          onClick={onOpenAccount}
          className="w-full flex items-center justify-between rounded-2xl border border-slate-200 bg-slate-50/70 px-4 py-3.5 text-sm text-slate-700 hover:bg-slate-100/70"
        >
          <span className="font-semibold text-slate-700">账号设置</span>
          <ChevronRight className="w-4 h-4 text-slate-400" />
        </button>
      )}

      <button
        type="button"
        onClick={onOpenDisplay}
        className="w-full flex items-center justify-between rounded-2xl border border-slate-200 bg-slate-50/70 px-4 py-3.5 text-sm text-slate-700 hover:bg-slate-100/70"
      >
        <span className="font-semibold text-slate-700">显示设置</span>
        <ChevronRight className="w-4 h-4 text-slate-400" />
      </button>

      <button
        type="button"
        onClick={onOpenQimen}
        className="w-full flex items-center justify-between rounded-2xl border border-slate-200 bg-slate-50/70 px-4 py-3.5 text-sm text-slate-700 hover:bg-slate-100/70"
      >
        <span className="font-semibold text-slate-700">奇门设置</span>
        <ChevronRight className="w-4 h-4 text-slate-400" />
      </button>

      {isLoggedIn && (
        <button
          type="button"
          onClick={onOpenNotice}
          className="w-full flex items-center justify-between rounded-2xl border border-slate-200 bg-slate-50/70 px-4 py-3.5 text-sm text-slate-700 hover:bg-slate-100/70"
        >
          <span className="font-semibold text-slate-700">用户须知</span>
          <ChevronRight className="w-4 h-4 text-slate-400" />
        </button>
      )}
    </div>
  );
};

export default UserSettingsSections;
